<template>
  <div class="ibox">
    <div class="ibox-title">
      <h3>Welcome {{profileCompanyName}}. Your account is almost setup</h3>
    </div>
    <div class="ibox-content">
      <ContentTitle>Account Progress</ContentTitle>
      <div class="row my-3">
        <div class="col-1">Account Email:</div>
        <div class="status-active font-weight-bold"><i class="fas fa-check-circle" /> Verified</div>
      </div>
      <div class="row my-3">
        <div class="col-1">Subscription:</div>
        <div class="status-active font-weight-bold"><i class="fas fa-check-circle" /> Setup</div>
      </div>
      <div class="mt-4">
        <br />
        <ContentTitle>Final Steps</ContentTitle>
        <ContentSubTitle>Sets up default records in the system to get started quicker. All these records can be created manually if required at a later date</ContentSubTitle>
      </div>
      <div class="row my-3 mt-4">
        <div class="col-2">
          <Tooltip helpStyle label="If selected, creates the default user groups">Setup default user groups</Tooltip>
        </div>
        <div class="col-10">            
          <FormCheckbox v-model="setup.createDefaultUserGroups" />
        </div>
      </div>
      <FormHorizontalRule />
      <div class="row my-3 mt-4">
        <div class="col-2">
          <Tooltip helpStyle label="If selected, creates the default pricing groups and ranges for a glass processor and/or glazier">Setup default glass configurations</Tooltip>
        </div>
        <div class="col-10">            
          <FormCheckbox v-model="setup.createDefaultGlassConfig" />
        </div>
      </div>
      <div class="row my-3">
        <div class="col-2">
          <Tooltip helpStyle label="If selected, creates the default stock categories for a glass processor and/or glazier">Setup default stock categories</Tooltip>
        </div>
        <div class="col-10">            
          <FormCheckbox v-model="setup.createDefaultStockCategories" />
        </div>
      </div>
      <FormHorizontalRule />
      <div class="row my-3">
        <div class="col-2">
          <Tooltip helpStyle label="If selected, creates the default system stock items for a glass processor and/or glazier">Setup default system stock items</Tooltip>
        </div>
        <div class="col-10">            
          <FormCheckbox v-model="setup.createDefaultSystemStock" />
        </div>
      </div>
      <div class="row my-3">
        <div class="col-2">
          <Tooltip helpStyle label="If selected, creates the default glass stock items for a glass processor and/or glazier">Setup default glass stock items</Tooltip>
        </div>
        <div class="col-10">            
          <FormCheckbox v-model="setup.createDefaultGlassStock" />
        </div>
      </div>
      <div class="row my-3">
        <div class="col-2">
          <Tooltip helpStyle label="If selected, creates the default glass service stock items for a glass processor and/or glazier">Setup default glass service stock items</Tooltip>
        </div>
        <div class="col-10">            
          <FormCheckbox v-model="setup.createDefaultGlassServiceStock" />
        </div>
      </div>
      <div class="row my-3">
        <div class="col-2">
          <Tooltip helpStyle label="If selected, creates the default general stock items for a glass processor and/or glazier">Setup default general stock items</Tooltip>
        </div>
        <div class="col-10">            
          <FormCheckbox v-model="setup.createDefaultGeneralStock" />
        </div>
      </div>

      <FormButton class="btn-lg btn-primary" @click="completeSetup" :loading="submitting"><i class="far fa-check-circle" /> Complete Setup</FormButton>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex"

export default {
  name: 'DashboardAccountActivate',
  data() {
    return {
      submitting: false,

      setup: {
        createDefaultUserGroups: true,
        createDefaultGlassConfig: true,
        createDefaultStockCategories: true,
        createDefaultSystemStock: true,
        createDefaultGlassStock: true,
        createDefaultGlassServiceStock: true,
        createDefaultGeneralStock: true,
      }
    }
  },
  computed: {
    ...mapState({
      profileCompanyName: state => state.profile.profileCompanyName,
    })
  },
  methods: {
    completeSetup() {
      let completeMessage = 'This will finalise the account setup'
      let options = []
      if(this.setup.createDefaultUserGroups)
        options.push('- Default user groups')
      if(this.setup.createDefaultGlassConfig)
        options.push('- Default glass configurations')
      if(this.setup.createDefaultStockCategories)
        options.push('- Default stock categories')
      if(this.setup.createDefaultSystemStock)
        options.push('- Default system stock items')
      if(this.setup.createDefaultGlassStock)
        options.push('- Default glass stock items')
      if(this.setup.createDefaultGlassServiceStock)
        options.push('- Default glass service stock items')
      if(this.setup.createDefaultGeneralStock)
        options.push('- Default general stock items')

      // Stock requires top 2 options set
      if(this.setup.createDefaultSystemStock || this.setup.createDefaultGlassStock || this.setup.createDefaultGlassServiceStock || this.setup.createDefaultGeneralStock) {
        if(!this.setup.createDefaultGlassConfig || !this.setup.createDefaultStockCategories) {
          this.errorMessage('Default options required', 'Glass Configurations and Stock Categories must be selected before adding default stock')
          return
        }
      }

      if(options.length > 0)
        completeMessage += '<br /><br />The following settings will be created:<br />' + options.join('<br />')

      this.confirmMessage('Complete account setup?', '', { html: completeMessage })
      .then(confirm => {
        if(confirm) {
          this.submitting = true
          this.$apiService.adminService.activateAccount({
            createDefaultUserGroups: this.setup.createDefaultUserGroups,
            createDefaultGlassConfig: this.setup.createDefaultGlassConfig,
            createDefaultStockCategories: this.setup.createDefaultStockCategories,
            createDefaultSystemStock: this.setup.createDefaultSystemStock,
            createDefaultGlassStock: this.setup.createDefaultGlassStock,
            createDefaultGlassServiceStock: this.setup.createDefaultGlassServiceStock,
            createDefaultGeneralStock: this.setup.createDefaultGeneralStock,
          })
          .then(response => {
            this.$emit('accountUpdated')
          })
          .catch(err => {
            this.displayNetworkError(err, 'Error activating account')
          })
          .finally(() => {
            this.submitting = false
          })
        }          
      })

    }
  }
}
</script>